import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import title from '../../img/title.svg';
import alarm from '../../img/alarm.svg';
import before from '../../img/before.svg';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:서브 헤더 공통, 클로디 아이콘과 알림메세지, 이전으로 가기 아이콘
 * Property: 
 *      LinkUrl: 링크주소 라우팅, LinkUrl="/Home"
 *      ComponentUrl: 컴포넌트 라우팅,  ComponentUrl="ComponentName" , LinkUrl 와 ComponentUrl중 하나만 사용 가능
 *      HeaderTitle: 헤더 이름,  HeaderTitle="명칭"
 *      IConClassName: 오른쪽에 보여지는 추가기능 아이콘 IConClassName="delete" or hide or write
 *      ContentState: 자식 페이지에서 부모페이지로 저환 할때 부모페이지 값의 설정이 필요한 경우 할당.
*/
export class HeaderSub2 extends Component {
    static displayName = HeaderSub2.name;
        
    constructor(props) {
        super(props);
        this.state = {
            AlarmCount: 0
        };
        Big3Common.Authentication(this); 
    }   
    async componentDidMount() {
        try {
            let data = await Big3Common.Get("api/MyPage/Notice/GetAllmMgtCount");
            if (data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ AlarmCount: parseInt(data.objectData) });
            }
        }
        catch (e) {
            console.log("componentDidMount: ", e)
        }
    }  
    
    PageLink() {
        
        if (this.props.LinkUrl !== undefined) {
            return (
                <div className="before pointer">
                    <Link to={this.props.LinkUrl} >
                        <img src={before} alt="이전화면" />
                    </Link>
                </div>
            )
        }
        else if (this.props.HistoryBack !== undefined && this.props.HistoryBack === true)
        {
           
            return (
                <div className="before pointer">
                    <Link to={-1} >
                        <img src={before} alt="이전화면" />
                    </Link>
                </div>
                )
        }
        else {
            if (this.props.ComponentUrl !== undefined && this.props.ContentState === undefined) {
                return (
                    <div className="before" onClick={() => this.props.RenderComponent(this.props.ComponentUrl)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }
            else if (this.props.ComponentUrl !== undefined && this.props.ContentState !== undefined) {
                //이전 부모 화면에서 전체 state값을 가져오고 다시 돌려 줌. 상태유지가 필요할때
                return (
                      <div className="before" onClick={() => this.props.RenderComponent(this.props.ComponentUrl, this.props.ContentState)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                      </div>
                );
            }
        }
    }
    PageAddFunc() {
    }
    render() {
        let LinkPage = this.PageLink();
        return (
            <header>
                <div className="main_title">
                    <Link className="main_logo" to="/">
                        <img src={title} alt="logo" />
                    </Link>
                    <div className="main_alarm_group">
                        <Link to="/MyPage/Notice/Index">
                            <img src={alarm} alt="공지알람아이콘" />
                            {this.state.AlarmCount === 0 ? "" : <span><b>{this.state.AlarmCount}</b></span>}
                        </Link>
                    </div>
                </div>
                <div className="nav">
                    {LinkPage}
                    <div className="page_title">
                        {this.props.HeaderTitle}
                    </div>
                    <div className="hide"></div>
                </div>
            </header>
        );
    }
}
 